import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "star",
  "use": "star-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"star\"><path fill-rule=\"evenodd\" d=\"M16 8a15.55 15.55 0 0 0-8 8 15.55 15.55 0 0 0-8-8 15.55 15.55 0 0 0 8-8 15.55 15.55 0 0 0 8 8\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol